
export function stickyBuyTicket() {
    const stickyBuyTicket = document.querySelector('.sticky-buyticket-wrap');
    if (!stickyBuyTicket) return;

    const toggleLastState = () => {
        const viewportBottom = window.scrollY + window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (viewportBottom >= documentHeight) {
            stickyBuyTicket.classList.add('last');
        } else {
            stickyBuyTicket.classList.remove('last');
        }
    };

    window.addEventListener('scroll', toggleLastState, { passive: true });
    window.addEventListener('resize', toggleLastState);
    toggleLastState();
}
